import {
  GET_ALL_ACTIVE_SUBJECTS,
  GET_JOB_STATUS,
  GET_SUBJECTS_AND_LEVELS,
  GET_REGISTRATION_INFORMATION,
  SEARCH_TAGS,
  FETCH_METRICS,
  FETCH_METRIC_OPTIONS,
  GET_TEMPORARY_UPLOAD_IMAGES,
} from "./Queries";
import { UPLOAD_TEMP_IMAGES } from "./Mutations";

export class CoreClient {
  constructor(client) {
    this.client = client;
  }

  async getSubjectsAndLevels() {
    const res = await this.client.query({
      query: GET_SUBJECTS_AND_LEVELS,
    });
    return res.data;
  }

  async getAllActiveSubjects() {
    const res = await this.client.query({
      query: GET_ALL_ACTIVE_SUBJECTS,
    });
    return res.data;
  }

  async getJobStatus({ jobId }) {
    const res = await this.client.query({
      query: GET_JOB_STATUS,
      fetchPolicy: "network-only",
      variables: {
        job: jobId,
      },
    });
    return res.data.jobStatus;
  }

  async searchTags({ query, educationLevel, subject }) {
    const res = await this.client.query({
      query: SEARCH_TAGS,
      fetchPolicy: "network-only",
      variables: {
        query: query,
        educationLevel,
        subject,
      },
    });
    return res.data.tags;
  }
  async getRegistrationInformation() {
    const res = await this.client.query({
      query: GET_REGISTRATION_INFORMATION,
    });
    return res.data;
  }

  async fetchMetricOptions({ metricType, schoolMetrics = false }) {
    const res = await this.client.query({
      query: FETCH_METRIC_OPTIONS,
      variables: {
        metricType: metricType,
        schoolMetrics: schoolMetrics,
      },
    });
    return res.data;
  }
  async fetchMetrics({
    metric,
    metricType,
    school = null,
    subscriptionCategory = "ALL",
  }) {
    const res = await this.client.query({
      query: FETCH_METRICS,
      variables: {
        metric: metric,
        subscriptionCategory,
        metricType: metricType,
        school: school,
      },
    });
    return res.data;
  }

  pollTemporaryImages({ uploadToken, pollInterval = 5000, onUpdate }) {
    return this.client
      .watchQuery({
        query: GET_TEMPORARY_UPLOAD_IMAGES,
        variables: { uploadToken },
        pollInterval,
        fetchPolicy: "network-only",
      })
      .subscribe({
        next: ({ data }) => onUpdate(data.temporaryImages),
        error: (error) => console.error("Polling error:", error),
      });
  }

  async uploadTempImages({ images, token }) {
    const res = await this.client.mutate({
      mutation: UPLOAD_TEMP_IMAGES,
      variables: {
        images,
        token,
      },
    });
    return res.data.uploadTempImages;
  }
}
